// extracted by mini-css-extract-plugin
export default {"sentinel":"Stick_sentinel__tJki6","sticky":"Stick_sticky__LRhLF","unsticky":"Stick_unsticky__e7kSH"};